export const UUID_PATTERN = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i;
export const UUID_EXACT_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const isUuid = value => typeof value === 'string' && UUID_EXACT_RE.test(value);

/**
 * Get the first UUID from a string that may contain multiple UUIDs
 * @param {string} str - The string to search for UUIDs
 * @returns {string | null} The first UUID found in the string, or null if no UUIDs are found
 */
export const getFirstUUID = str => {
  const match = typeof str === 'string' ? str.match(UUID_PATTERN) : null;
  return match ? match[0] : null;
};
